
/**
 * @module Classes
 */

/**
 * Adds the given class to the element if the class does not already exist.
 * @param {HTMLElement} element The element.
 * @param {string} className The class name.
 * @example
 * // <div class="item"></div>
 * addClass(element, 'book')
 * // <div class="item book"></div>
 */
export function addClass( element, className )
{
    if ( ! element.getAttribute )
    {
        return;
    }

    let classes = element.getAttribute( 'class' );

    classes = classes ? classes.split(' ') : [];


    if ( classes.indexOf( className ) === -1 )
    {
        classes.push( className );
    }

    element.setAttribute( 'class', classes.join( ' ' ) );
}

/**
 * Removes the given class from the element.
 * @param {HTMLElement} element The element.
 * @param {string} className The class name.
 * @example
 * // <div class="item book"></div>
 * removeClass(element, 'book')
 * // <div class="item"></div>
 */
export function removeClass( element, className )
{
    if ( ! element.getAttribute )
    {
        return;
    }

    let classes = element.getAttribute( 'class' );

    classes = classes ? classes.split(' ') : [];


    let index = classes.indexOf( className );

    if ( index > -1 )
    {
        classes.splice( index, 1 );
    }

    element.setAttribute( 'class', classes.join( ' ' ) );
}

/**
 * Check if the given class exists on the element.
 * @param {HTMLElement} element The element.
 * @param {string} className The class to check.
 * @example
 * // <div class="item"></div>
 * 
 * // returns true
 * hasClass(element, 'item')
 * 
 * // returns false
 * hasClass(element, 'book')
 */
export function hasClass( element, className )
{
    let classes = ' ' + element.className + ' ';

    return classes.indexOf( ' ' + className + ' ' ) > -1;
}

/**
 * Merges an object or array into a string of classes separated by spaces.
 * @param {(string|object)} className The classes to merge.
 * @example
 * // returns "hello world"
 * joinClasses({ foo: "hello", hello: "world" })
 */
export function joinClasses(className)
{
    let classes = [];

    if (typeof className === 'string')
    {
        return className;
    }

    if (typeof className === 'object')
    {
        for (let key in className)
        {
            if (typeof className[key] === 'string')
            {
                classes.push(className[key]);
            }
        }
    }

    return classes.join(' ');
}